<section class="rate-request">
    <div class="top-section">
        <h3>
            Freight Enquiry
        </h3>
    </div>
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <h4 class="main-title">
                    Account Details
                </h4> 
                <form [formGroup]="registrationForm" (ngSubmit)="onsubmit()">
                 <div class="form-group m-t-30">
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <div class="section-relative input-name">
                                <input type="text" formControlName="firstName" class="form-control" id="Inputtext"
                                    aria-describedby="textHelp" placeholder="First Name">
                                <img src="../../../assets/images/user.svg" class="user-icon">

                                <div *ngIf="hasErroraccount('firstName', 'required') && submitted"
                                    class="invalid-Validation">
                                    First Name is required
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="section-relative input-name">
                                <input type="text" formControlName="lastName" class="form-control" id="Inputtext"
                                    aria-describedby="textHelp" placeholder="Last Name">
                                <img src="../../../assets/images/user.svg" class="user-icon">
                                <div *ngIf="hasErroraccount('lastName', 'required') && submitted"
                                    class="invalid-Validation">
                                    Last Name is required
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="section-relative">
                                <input type="email" formControlName="email" class="form-control" id="InputEmail"
                                    aria-describedby="emailHelp" placeholder="Email" (blur)="checkEmailExist()">
                                <img src="../../../assets/images/envelope.svg" class="user-icon pass-icon-sec">

                                <div *ngIf="hasErroraccount('email', 'required') && submitted" class="invalid-Validation">
                                    Email is required
                                </div>
                                <div *ngIf="hasErroraccount('email', 'email') && submitted" class="invalid-Validation">
                                    Invalid Email
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-4 form-group">
                            <div class="section-relative">
                                <input type="password" formControlName="password" class="form-control" pTooltip="Passwords must contain at least eight characters." id="exampleInputPassword1"
                                    placeholder="Password" (keyup)="checkPasswords()">
                                <img src="../../../assets/images/password.svg" class="user-icon pass-icon">

                                <div *ngIf="hasErroraccount('password', 'required') && submitted"
                                    class="invalid-Validation">
                                    Password is required
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="section-relative">
                                <input type="password" formControlName="confirmPassword" class="form-control"
                                    id="exampleInputPassword1" placeholder="Confirm Password" pTooltip="Passwords must contain at least eight characters." (keyup)="checkPasswords()">
                                <img src="../../../assets/images/password.svg" class="user-icon pass-icon">

                                <div *ngIf="hasErroraccount('confirmPassword', 'required') && submitted"
                                    class="invalid-Validation">
                                    Confirm Password is required
                                </div>
                                <div *ngIf="confirmPassNotSame" class="invalid-Validation">
                                    Confirm Password not match with password
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="section-relative">
                                <input type="text" formControlName="companyName" class="form-control" id="Inputtext"
                                    aria-describedby="textHelp" placeholder="Company Name">
                                <img src="../../../assets/images/company.svg" class="user-icon">

                                <!-- <div *ngIf="hasError('companyName', 'required') && submitted"
                                    class="invalid-Validation">
                                    Company Name is required
                                </div> -->
                            </div>
                        </div>

                    </div>
                    <div class="row mt-3">
                        <div class="col-md-4 form-group">
                            <div class="section-relative input-name">
                                <input type="text" formControlName="phoneNumber" maxLength="20" class="form-control"
                                    id="Inputtext" aria-describedby="textHelp" placeholder="Phone Number">
                                <img src="../../../assets/images/phone-numbers-call.svg" class="user-icon">

                                <div *ngIf="hasErroraccount('phoneNumber', 'required') && submitted"
                                    class="invalid-Validation">
                                    Phone Number is required
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="section-relative input-name pRel">
                                <!-- <input type="text" formControlName="countryName" class="form-control" id="Inputtext"
                                    aria-describedby="textHelp" placeholder="Country Name"> -->
                                <p-dropdown [options]="countries" formControlName="country"
                                    optionLabel="countryName" class="select-dropdown-sec" placeholder="Country"
                                    [virtualScroll]="true" [itemSize]="31" [filter]="true"></p-dropdown>
                                    <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span>
                                <!-- <img src="../../../assets/images/country.svg" class="user-icon pass-icon-sec-coun"> -->

                                <div *ngIf="hasErroraccount('country', 'required') && submitted"
                                    class="invalid-Validation">
                                    Country Name is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="hr-1 m-t-30">
                </div>
                </form>
                <form [formGroup]="ratereqform" class="search-section-right" (ngSubmit)="onsubmit()">
                    <div class="form-group m-t-30 from-to-section">
                        <div class="row">
                            <div class="col-md-6">
                                <h4 class="main-title">
                                    From
                                </h4>
                                <div class="row m-t-30 m-r-0">
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal ">
                                            Country
                                        </label>
                                        <div class="pRel">
                                            <p-dropdown [options]="countries" [readonly]="newReadonly == true?newReadonly: readonly"
                                                optionLabel="countryName" formControlName="fromcountryid"
                                                placeholder="Select Country" [virtualScroll]="true" [filter]="false"
                                                class="p-dropdown" (onChange)="getportbycountryid($event,'frmport')">
                                            </p-dropdown>
                                            <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                        </div>
                                        <!-- <select name="" formControlName="fromcountryid" class="form-control" id="" (change)="getportbycountryid($event,'frmport')">
                                            <option value="">--Select One--</option>              
                                            <option [value]="category.id" *ngFor="let category of countries">
                                              {{category.countryName  }}</option>                                       
                                          </select> -->

                                        <!-- <p-dropdown [options]="countries" formControlName="fromcountryid"
                                            optionLabel="countryName" class="select-dropdown-sec" placeholder="Country"
                                            [virtualScroll]="true" [itemSize]="31" [filter]="false"
                                            (onChange)="getportbycountryid($event,'frmport')"></p-dropdown> -->
                                        <div *ngIf="hasError('fromcountryid', 'required') && submitted"
                                            class="invalid-Validation">
                                            From Country is required
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal">
                                            Port
                                        </label>

                                        <!-- <select name="" formControlName="fromportid" class="form-control" id="">
                                            <option value="">--Select One--</option>
              
                                            <option [value]="category.id" *ngFor="let category of fromport">
                                              {{category.portName  }}</option>                                       
                                          </select> -->
                                        <div class="pRel">
                                            <p-dropdown [options]="fromport" [readonly]="newReadonly == true?newReadonly: readonly"
                                                formControlName="fromportid" optionLabel="portName"
                                                class="select-dropdown-sec" placeholder="Port" [virtualScroll]="true"
                                                [itemSize]="31" [filter]="false">
                                            </p-dropdown>
                                            <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                        </div>

                                        <div *ngIf="hasError('fromportid', 'required') && submitted"
                                            class="invalid-Validation">
                                            From Port is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h4 class="main-title">
                                    To
                                </h4>
                                <div class="row m-t-30 m-l-0">
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal">
                                            Country
                                        </label>
                                        <!-- <select name="" formControlName="tocountryid" class="form-control" id="" (change)="getportbycountryid($event,'toport')">
                                            <option value="">--Select One--</option>
              
                                            <option [value]="category.id" *ngFor="let category of countries">
                                              {{category.countryName  }}</option>                                       
                                          </select> -->
                                        <div class="pRel">
                                            <p-dropdown [options]="countries" [readonly]="newReadonly == true?newReadonly: readonly"
                                                formControlName="tocountryid" optionLabel="countryName"
                                                class="select-dropdown-sec" placeholder="Country" [virtualScroll]="true"
                                                [itemSize]="31" [filter]="false"
                                                (onChange)="getportbycountryid($event,'toport')"></p-dropdown>
                                            <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                        </div>
                                        <div *ngIf="hasError('tocountryid', 'required') && submitted"
                                            class="invalid-Validation">
                                            To Country is required
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal">
                                            Port
                                        </label>
                                        <!-- <select name="" formControlName="toportid" class="form-control" id="">
                                            <option value="">--Select One--</option>
              
                                            <option [value]="category.id" *ngFor="let category of toport">
                                              {{category.portName  }}</option>                                       
                                          </select> -->
                                        <div class="pRel">
                                            <p-dropdown [options]="toport" [readonly]="newReadonly == true?newReadonly: readonly" optionLabel="portName"
                                                formControlName="toportid" class="select-dropdown-sec"
                                                placeholder="To Port" [virtualScroll]="true" [itemSize]="31"
                                                [filter]="false">
                                            </p-dropdown>
                                            <span class="downArrow"><img
                                                    src="../../../../assets/images/arrow.png" /></span>
                                        </div>
                                        <div *ngIf="hasError('toportid', 'required') && submitted"
                                            class="invalid-Validation">
                                            To Port is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <span class="arrow arrow-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18.793" height="29.276"
                                    viewBox="0 0 19.793 20.276">
                                    <defs>
                                        <style>
                                            .a {
                                                fill: #15536b;
                                            }
                                        </style>
                                    </defs>
                                    <g transform="translate(-23.998 -87.999)">
                                        <path class="a"
                                            d="M161.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,161.447,108.275Z"
                                            transform="translate(-127.793 0)" />
                                        <path class="a"
                                            d="M25.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,25.447,108.275Z"
                                            transform="translate(0 0)" />
                                    </g>
                                </svg>
                            </span>
                        </div>
                        <hr class="hr-1 m-t-30">
                    </div>
                    <div class="form-group m-t-30">
                        <h4 class="main-title">
                            Consignment Details
                        </h4>
                        <div class="row m-t-30">
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    Cargo Class
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="cargoTypes" [readonly]="readonly" optionLabel="name"
                                        formControlName="cargoclass" placeholder="Select Cargo Type" class="p-dropdown"
                                        (onChange)="getCargoSegment($event)" [itemSize]="31" [filter]="false"></p-dropdown>
                                    <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                </div>
                                <!-- <select class="form-control" formControlName="cargoclass"
                                    placeholder="Select Cargo" (change)="getdropdownvalue($event)">
                                    <option value="">--Select Cargo Class --</option>
                                    <option value="1">Auto</option>
                                    <option value="2">Breakbulk</option>
                                    <option value="3">High & Heavy</option>
                                </select> -->
                                <div *ngIf="hasError('cargoclass', 'required') && submitted" class="invalid-Validation">
                                    Cargo Class is required
                                </div>

                            </div>
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    Cargo Segment
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="cargoSegments" [readonly]="readonly" class="p-dropdown"
                                        optionLabel="name" formControlName="cargoconsigment"
                                        placeholder="Select Cargo Segment" [itemSize]="31" [virtualScroll]="true" [filter]="false">
                                    </p-dropdown>
                                    <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                </div>
                                <!-- <select class="form-control " placeholder="Select Segment"
                                    formControlName="cargoconsigment" *ngIf="isauto">
                                    <option value="">--Select Segment--</option>
                                    <option value="1">Car (up to 165 cm high)</option>
                                    <option value="2">Car or Van (above 165 cm and up to 215 cm high)</option>
                                    <option value="3">High Van (above 215 cm high)</option>
                                </select> -->
                                <!-- <select class="form-control " formControlName="cargoconsigment"
                                    placeholder="Select Segment" *ngIf="isbreakbulk">
                                    <option value="">&nbsp;</option>

                                    <option value="1">Aviation</option>

                                    <option value="2">Boats and Yachts</option>

                                    <option value="3">Iron and Steel products</option>

                                    <option value="4">Machinery &amp; Machine tools</option>

                                    <option value="5">Masts, Kelly bars or Poles</option>

                                    <option value="6">Masts and/or Keels travelling w Boat or Yacht</option>

                                    <option value="7">Mining and Construction equipment</option>

                                    <option value="8">Oil &amp; Gas Industry</option>

                                    <option value="9">Personal effects travelling with a Car or Van</option>

                                    <option value="10">Power Generation equipment (e.g. transformers, turbines,
                                        generators,
                                        wind power equipment etc)</option>

                                    <option value="11">Rail (e.g. rail cars, locomotives)</option>

                                    <option value="12">Rubber products</option>

                                    <option value="13">Spare parts travelling with High&amp;Heavy rolling units</option>

                                    <option value="14">Other</option>
                                </select>
                                <select class="form-control " formControlName="cargoconsigment"
                                    placeholder="Select Cargo" *ngIf="ishighandhevy">
                                    <option value="">&nbsp;</option>

                                    <option value="1">Agricultural tractors</option>

                                    <option value="2">Boats and Yachts on trailers</option>

                                    <option value="3">Buses</option>

                                    <option value="4">Caravans</option>

                                    <option value="5">Forklifts</option>

                                    <option value="6">Mining and Construction equipment</option>

                                    <option value="7">Mobile Homes</option>

                                    <option value="8">Other Agricultural and Forestry equipment</option>

                                    <option value="9">Other RoRo equipment</option>

                                    <option value="10">Trucks or Truck trailers</option>
                                </select> -->

                                <div *ngIf="hasError('cargoconsigment', 'required') && submitted"
                                    class="invalid-Validation">
                                    Cargo Segment is required
                                </div>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    Condition
                                </label>
                                <!-- <select class="form-control" formControlName="condition">
                                    <option value="">--Select Condition--</option>
                                    <option value="1">New</option>
                                    <option value="2">Used</option>
                                </select> -->
                                <div class="pRel">
                                    <p-dropdown [options]="cargoConditions" [readonly]="readonly" class="p-dropdown"
                                        optionLabel="viewValue" formControlName="condition"
                                        placeholder="Select Condition" [itemSize]="31" [filter]="false">
                                    </p-dropdown>
                                    <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                </div>
                                <div *ngIf="hasError('condition', 'required') && submitted" class="invalid-Validation">
                                    Condition is required
                                </div>
                            </div>

                        </div>
                        <div class="row m-t-30">
                            <!-- <div class="col-md-4 form-group">
                            <label class="custom-labal">
                                Cargo Type
                            </label>
                            <select class="form-control">
                                <option>Select</option>
                            </select>
                        </div> -->
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    When can cargo be in loadport?
                                </label>
                                <div class="">
                                    <p-calendar [readonlyInput]="true" formControlName="whencancargolanport"
                                        showIcon="true" showButtonBar="true" placeholder="Date" [minDate]="minDate"
                                        [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                                        icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy">
                                    </p-calendar>

                                </div>
                                <div *ngIf="hasError('whencancargolanport', 'required') && submitted"
                                    class="invalid-Validation">
                                    When can cargo be in loadport? is required
                                </div>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    Number of Units
                                </label>
                                <input type="number" class="form-control" formControlName="noofunits" placeholder="0"
                                    step="1" (change)="FixedNumber()">
                                <div *ngIf="hasError('noofunits', 'required') && submitted" class="invalid-Validation">
                                    No Of Units is required
                                </div>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    Shipping Lines
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="shippinglineslist" [readonly]="newReadonly == true?newReadonly: readonly"
                                        formControlName="shippinglineId" class="p-dropdown"
                                        optionLabel="shippingLineName" placeholder="Select ShippingLines"
                                        [filter]="false">
                                    </p-dropdown>
                                    <span class="downArrow"><img src="../../../../assets/images/arrow.png" /></span>
                                </div>
                                <div *ngIf="hasError('condition', 'required') && submitted" class="invalid-Validation">
                                    Condition is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <div class="row">
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Length(m)
                                </label>
                                <input type="textbox" class="form-control" formControlName="length" placeholder="0.00"
                                name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="calculateSQM($event,'length')">
                            <div *ngIf="hasError('length', 'required') && submitted" class="invalid-Validation">
                                Length is required
                            </div>
                            <div *ngIf="lengthvalid" class="invalid-Validation">
                            Length should be less than or Equal to 25
                            </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Width(m)
                                </label>
                                <input type="textbox" class="form-control" formControlName="width" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" max (change)="calculateSQM($event,'width')">
                                <div *ngIf="hasError('width', 'required') && submitted" class="invalid-Validation">
                                    Width is required
                                </div>
                                <div *ngIf="widthvalid" class="invalid-Validation">
                                    Width should be less than or Equal to 7
                                    </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Height(m)
                                </label>
                                <input type="textbox" class="form-control" formControlName="height" placeholder="0.00"
                                name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="calulateCBM()">
                            <div *ngIf="hasError('height', 'required') && submitted" class="invalid-Validation">
                                Height is required
                            </div>
                            <div *ngIf="heightvalid" class="invalid-Validation">
                                Height should be less than or Equal to 6
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Weight(mt)
                                </label>
                                <input type="textbox" formControlName="weight" class="form-control" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$">
                                <div *ngIf="hasError('weight', 'required') && submitted" class="invalid-Validation">
                                    Weight is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <div class="row">
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Sqm(m2)
                                </label>
                                <input type="textbox" formControlName="Sqm" class="form-control" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" readonly>
                                <div *ngIf="hasError('Sqm', 'required') && submitted" class="invalid-Validation">
                                    Sqm is required
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Cbm(m3)
                                </label>
                                <input type="textbox" class="form-control" formControlName="cbm" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" readonly>
                                <div *ngIf="hasError('cbm', 'required') && submitted" class="invalid-Validation">
                                    Cbm is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <div class="row">
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    <span> Package And Description</span>(Car & H&H: make,model manufacture
                                    year,self-propelled.Break Bulk: Packging Description)
                                </label>
                                <textarea rows="1" maxlength="250" formControlName="description" class="form-control"
                                    (keyup)="onKeyPress()" placeholder="Description">
                                </textarea>
                                <div class="font-12 mt-2">
                                    <span *ngIf="descriptionLength == false">Total characters: {{totalChar}}</span>
                                    <span *ngIf="descriptionLength == true">Remaining characters: {{totalChar}}</span>
                                </div>
                                <div *ngIf="hasError('description', 'required') && submitted"
                                    class="invalid-Validation">
                                    Package and Description is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12 text-right mb-3">
                                <!-- <button class="btn  btn-signIn" routerLink="/raterequestlist">
                                    Back To List
                                </button> &nbsp; -->
                                <button class="btn  btn-signIn" type="submit">
                                    SUBMIT
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </div>
</section>